import { TextField, type TextFieldProps } from '@mui/material';
import { forwardRef } from 'react';
import { LabeledField } from '../LabeledField';

/**
 * @tier molecule
 *
 * Multi-line text input with a stacked label. Same theming as
 * `VyTextField`. Used for invoice line item descriptions, notes, and
 * similar long-form input.
 */
export type VyTextareaProps = Omit<TextFieldProps, 'multiline' | 'label' | 'helperText'> & {
  /** Field label rendered above the input. */
  label?: string;
  /** Hint shown below the input. Becomes the error message when `error` is true. */
  helperText?: string;
  /** Minimum number of visible rows. Default 2. */
  minRows?: number;
  /** Maximum visible rows before the textarea scrolls. Default 8. */
  maxRows?: number;
};

export const VyTextarea = forwardRef<HTMLDivElement, VyTextareaProps>(
  function VyTextarea(
    { label, helperText, error, fullWidth = true, minRows = 2, maxRows = 8, ...rest },
    ref,
  ) {
    return (
      <LabeledField label={label} helperText={helperText} error={error}>
        <TextField
          ref={ref}
          variant="outlined"
          size="small"
          multiline
          minRows={minRows}
          maxRows={maxRows}
          fullWidth={fullWidth}
          error={error}
          {...rest}
        />
      </LabeledField>
    );
  },
);
